<template>
  <div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card class="mb-base">
        <vs-table :max-items="5" pagination :data="bulkUpload.pageItems" search>
          <template slot="header">
            <div class="list-heading">{{ $t("admin.label.Bulk Uploads") }}</div>
            <span class="vx-col order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="handleUploadFile"
                size="small"
              >
                {{ $t("admin.label.Upload File") }}</vs-button
              >
            </span>
            <span class="vx-col order-1">
              <vs-button
                color="primary"
                icon-pack="feather"
                type="border"
                title="Refresh"
                icon="icon-refresh-ccw"
                class="truncate w-h-32"
                size="small"
                @click="refreshData"
              >
              </vs-button>
            </span>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("admin.label.Upload Process") }}</vs-th>
            <vs-th>{{ $t("admin.label.Upload File Path") }}</vs-th>
            <vs-th>{{ $t("admin.label.Process Date") }}</vs-th>
            <vs-th>{{ $t("admin.label.Process/Total Records") }}</vs-th>
            <vs-th>{{ $t("admin.label.Status") }}</vs-th>
            <vs-th>{{ $t("admin.label.Action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" v-for="(uploads, index) in data">
              <vs-td :data="uploads.uploadProcess">{{
                uploads.uploadProcess
              }}</vs-td>
              <vs-td :data="uploads.uploadFilePath">{{
                uploads.uploadFilePath
              }}</vs-td>
              <vs-td :data="getDate(uploads.processDate)">{{
                getDate(uploads.processDate)
              }}</vs-td>
              <vs-td
                >{{ uploads.processRecords }}/{{ uploads.totalRecords }}</vs-td
              >
              <vs-td :data="uploads.processStatus">{{
                uploads.processStatus
              }}</vs-td>
              <!--<vs-td :data="ticket.problemCode">{{ticket.problemCode}}</vs-td>
            <vs-td :data="ticket.status">{{ticket.status}}</vs-td>
            <vs-td :data="ticket.userName">{{ticket.userName}}</vs-td>

            <vs-td :data="ticket.lastComment">{{ticket.lastComment}}</vs-td>
            <vs-td :data="ticket.file">{{ticket.file}}</vs-td>-->
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    v-if="uploads.processStatus === 'NEW'"
                    title="Process File "
                    icon="PlayIcon"
                    @click="processData(uploads.id)"
                    svgClasses="w-5 h-5 stroke-current"
                    class="icon_row text-success"
                  />
                  <feather-icon
                    v-if="uploads.processStatus != 'NEW'"
                    title="Download Log File "
                    icon="DownloadCloudIcon"
                    @click="downloadStatement(uploads.id)"
                    svgClasses="w-5 h-5 stroke-current text-cloud"
                    class="icon_row"
                  />
                  <feather-icon
                    v-if="uploads.processStatus != 'NEW'"
                    title="Download Uploaded File"
                    icon="DownloadIcon"
                    class="text-warning icon_row"
                    @click="downloadFile(uploads.id, uploads.uploadFilePath)"
                    svgClasses="w-5 h-5 stroke-current"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          classContent="popup-example"
          :title="$t('admin.label.Documents Uploads')"
          :active.sync="bulkUploadsPopup"
        >
          <ValidationObserver ref="observer">
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full">
                <div class="vx-col mb-2 w-full">
                  <small class="date-label font-semibold">{{
                    $t("admin.label.Name")
                  }}</small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('admin.label.Name')"
                    :key="resetKey"
                  >
                    <v-select
                      label="name"
                      v-model="bulkUploads.status"
                      :options="uploadName"
                      :reduce="(name) => name.name"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                      <template v-slot:option="option">{{
                        option.name
                      }}</template>
                    </v-select>
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col mb-2 w-full">
                  <small class="date-label font-semibold">{{
                    $t("admin.label.Description")
                  }}</small>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('admin.label.Description')"
                    :key="resetKey"
                  >
                    <vs-textarea v-model="bulkUploads.description" />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col w-full">
                  <pick-file @fileUpdate="uploadOnChange" :key="resetKey"/>
                </div>
                <div class="vx-col w-full flex justify-center mt-3">
                  <span class="ml-4 mr-1">
                    <vs-button
                      type="border"
                      @click="bulkUploadsPopup = false"
                      >{{ $t("admin.label.Cancel") }}</vs-button
                    >
                  </span>
                  <span class="ml-1 mr-2">
                    <vs-button @click="addUploadFile()">{{
                      $t("admin.label.Submit")
                    }}</vs-button>
                  </span>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import _ from "lodash";
import vSelect from "vue-select";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { setHeader, removeHeader } from "@/http";
import { BUCKET_BASE_URL } from "@/http/index";
import PickFile from "../../../components/PickFile.vue";
import { mapState } from "vuex";
const bulkUploadsObj = {
  status: "",
  description: "",
  file: "",
};
export default {
  data() {
    return {
      loading: false,
      bulkUploadsPopup: false,
      bulkUploads: { ...bulkUploadsObj },
      resetKey: 0,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      uploadName: [
        { name: "Customer Activation" },
        { name: "Transfer" },
        { name: "CustomerRegistration" },
        { name: "Hardware Items" },
        { name: "Adjustments" },
        { name: "Payments" },
        { name: "MRN" },
        { name: "MoveItemsale" },
        { name: "EPG" },
        { name: "Transfer" },
        { name: "Media Assets" },
        { name: "Organization" },
        { name: "AddPlan" },
        { name: "ChangePlan" },
        { name: "CancelPlan" },
        { name: "ClientServiceSuspend" },
        { name: "ClientServicereactive" },
        { name: "MrnCarton" },
        { name: "Create Lead" },
        { name: "ServiceActivation" },
        { name: "ServicePlanActivation" },
        { name: "ClientServiceTermination" },
        { name: "Create User" },
        { name: "RenewalPlan" },
        { name: "EditCustomer" },
        { name: "Upload ClientList" },
      ],
    };
  },
  components: {
    "v-select": vSelect,
    AtomSpinner,
    PickFile,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      bulkUpload: (state) => state.admin.bulkUploads,
    }),
  },
  methods: {
    async processData(id) {
      try {
        await this.$store.dispatch("admin/processFile", id);
        this.$toasted.success("File processed successfully", {
          duration: 5000,
        });
        this.getDataUploads();
      } catch (error) {
        this.$toasted.error("Failed to process file", {
          duration: 5000,
        });
      }
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    handleUploadFile() {
      this.resetKey++;
      this.bulkUploads = { ...bulkUploadsObj };
      this.bulkUploadsPopup = true;
    },
    async addUploadFile() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("file", this.bulkUploads.file);
        formData.append("status", this.bulkUploads.status);
        formData.append("description", this.bulkUploads.description);
        await this.$store.dispatch(
          "admin/addBulkUploadsAction",
          formData,
          this.createFormData(this.bulkUploads)
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Document Uploaded successfully!",
          type: "success",
        });
        removeHeader("Content-Type");
        this.getDataUploads();
        this.bulkUploadsPopup = false;
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    downloadStatement(id) {
      this.downloadFile2(
        BUCKET_BASE_URL +
          `/datauploads/printlog/${id}?tenantIdentifier=default`,
        `log${id}.xlsx`
      );
    },
    async downloadFile2(fullLink, name) {
      try {
        const bearerToken = sessionStorage.getItem("ngb:bearer_token") || null;
        const response = await fetch(fullLink, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the statement:", error);
        this.$vs.notify({
          title: "Download Failed",
          text: "Unable to download the statement. Please try again.",
          color: "danger",
        });
      }
    },
    downloadFile(id, path) {
      this.$store
        .dispatch("inventory/downloadFileAction", id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", path.replace(/^.*[\\/]/, ""));
          document.body.appendChild(link);
          link.click();
        })
        .catch(console.error);
    },
    uploadOnChange(file) {
      this.bulkUploads.file = file ? file : null;
    },
    async getDataUploads() {
      this.loading = true;
      try {
        await this.$store.dispatch("admin/setBulkUploads");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async refreshData() {
      await this.getDataUploads();
    },
    createFormData(object) {
      let formData = new FormData();
      _.forEach(object, (value, key) => {
        formData.append(key, value);
      });
      return formData;
    },
  },
  created() {
    this.getDataUploads();
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.w-h-32 {
  height: 32px !important;
  width: 32px !important;
}
</style>
